import { PageContainer } from '@components'
import { Certifications } from '@views/Certifications'
import { useRequestParams } from '@hooks'
import { useEffect } from 'react'
import { store } from '@store'
import { GetCertificationsPayloadType } from '@api'

export const CertificationsPage = () => {
  const certificationsFiltered = store.use.certificationsFiltered()
  const getCertificationsAction = store.use.getCertificationsAction().call
  const isLoadingGetCertificationsAction = store.use.getCertificationsAction().status === 'LOADING'

  const { afterPageChange, reqParams, pagination } =
    useRequestParams<GetCertificationsPayloadType>()

  useEffect(() => {
    getCertificationsAction(reqParams)
  }, [JSON.stringify(reqParams)])

  useEffect(() => {
    afterPageChange(certificationsFiltered.length)
  }, [certificationsFiltered.length])

  return (
    <PageContainer>
      <Certifications
        certifications={certificationsFiltered}
        isLoading={isLoadingGetCertificationsAction}
        tableProps={{ pagination }}
      />
    </PageContainer>
  )
}

export default CertificationsPage
